import React, { useState } from "react";
import { Button, Stack, TextField, Typography } from "@mui/material";
import axios from "axios";
import modalThemeTextStyle from "../../components/generate-captions/modal-theme-style";
import MailCheck from "react-mailcheck";
import "../../styles/captionAI.scss";

const CaptionAISignIn = (props) => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  let signInAttempts = 10;

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleBack = () => {
    props.toggleSignIn();
  };

  const checkSignedIn = () => {

    if (props.showSignIn && signInAttempts > 0) {      
      signInAttempts--;
      props.setPollForJWT(signInAttempts);
      
      setTimeout(() => {
        checkSignedIn();
      }, [60000])
    }

  }

  const handleEmailSubmit = () => {
    setSubmitted(true);

    axios
      .post(`/user/email/link?email=${email}`, {})
      .then((response) => {
        props.setEmail(email);

        // Commenting check out until SDT-1363 is complete
        // checkSignedIn();
      })
      .catch((error) => {
        console.log(error);
        setSubmitError(true);
        setSubmitted(false);
      });
  };
  return (
    <div className="captionAI-signup-container">
      <div className="captionAI-signup-page">
        <div className="captionAI-signup-page-cover">
          <div className="captionAI-signup-page-content">
            <i
              className="fa fa-fw fa-arrow-left clickable font-awesome-icon-style"
              onClick={handleBack}
            ></i>
            <img
              src="https://d23ypky16g08sh.cloudfront.net/res/cc-cloud-logo-gray-full.png"
              alt="Cloud Campaign Gray Logo"
            />
            <h4>Welcome</h4>
            {submitted ? (
              <div className="verfication-text-container">
                <h5>Check Your Email for the Verification Link</h5>
                <h5>
                  We are thrilled to have you on board as a user of CaptionAI.
                  To get started, we've sent a magic link to your email address.
                  Simply click on the link or copy and paste it into your web
                  browser to access your account
                </h5>
              </div>
            ) : (
              <>
                <Stack margin={2}>
                  {submitError ? (
                    <h5 className="email-text">
                      Something went wrong, please try again.
                    </h5>
                  ) : (
                    <h5 className="email-text">Email address</h5>
                  )}
                  <MailCheck email={email}>
                    {(suggestion) => (
                      <div>
                        <TextField
                          variant="outlined"
                          onChange={handleEmailChange}
                          value={email}
                          inputProps={{
                            style: modalThemeTextStyle,
                            "data-testid": "captionAI-sign-in-email",
                          }}
                          error={suggestion !== null}
                          fullWidth
                        />
                        {suggestion && (
                          <h5
                            className="clickable"
                            onClick={() => setEmail(suggestion.full)}
                          >
                            Did you mean {suggestion.full}?
                          </h5>
                        )}
                      </div>
                    )}
                  </MailCheck>
                </Stack>
                <Stack direction="row" justifyContent="center" margin={2}>
                  <Button
                    variant="contained"
                    color="cc"
                    onClick={handleEmailSubmit}
                    disabled={email === ""}
                    data-testid="captionAI-send-email"
                  >
                    Sign Up / Log in
                  </Button>
                </Stack>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaptionAISignIn;
